import { z } from 'zod';
import { useSuspenseQuery } from '@tanstack/react-query';
import { Interval } from 'app/agriculture/AgTimeline/types';
import { snapshotConfig } from 'app/agriculture/queries/snapshots/config/snapshotConfig';
import {
    AggregatableSnapshotType,
    aggregationSnapshotConfig,
} from 'app/agriculture/queries/snapshots/config/snapshotAggregationConfig';

type ChartInterval = 'hour' | 'day' | 'week' | 'month' | 'year';

export function useAggregateTableData<TSnapshot extends AggregatableSnapshotType>({
    snapshotType,
    deviceId,
    intervalUnit,
    interval: { start, end },
}: {
    deviceId: string;
    snapshotType: TSnapshot;
    intervalUnit: ChartInterval;
    interval: Interval<Date>;
}) {
    const { data } = useSuspenseQuery({
        queryKey: [
            `${snapshotConfig[snapshotType].endpoint}agg/`,
            {
                device_id: deviceId,
                timestamp_start: start.toISOString(),
                timestamp_end: end.toISOString(),
                interval: intervalUnit,
            },
        ],
    });

    const schema = aggregationSnapshotConfig[snapshotType];
    return z.array(schema).parse(data) as z.infer<typeof schema>[];
}
